import type { PasswordRuleKey } from '@/utils/passwordPolicy';

/**
 * Short labels for the password policy's rules (`@/utils/passwordPolicy`
 * keeps the long ones for its error messages). `login` namespace keys.
 */
export const RULE_LABELS: Record<PasswordRuleKey, string> = {
  length: 'At least {{min}} characters',
  uppercase: 'An uppercase letter',
  lowercase: 'A lowercase letter',
  number: 'A number',
  special: 'A symbol, like ! or #',
  notCommon: 'Not a common password',
  noEmail: "Doesn't contain your email",
};

export const PASSWORD_HINT =
  'Use {{min}} or more characters with upper and lower case letters, a number and a symbol.';
